module.exports = __webpack_public_path__ + "static/media/mail-to.f5302853.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/mail-to.png
// module id = 256
// module chunks = 0